import { Component, OnInit, Input, Renderer2, ViewChild, AfterViewInit } from "@angular/core";
import { AppData, ToastService } from "src/app/shared";
import { MenuItem, Addons, Variant } from "src/app/shared/models/menu-item";
import { ErrorMessage } from "src/app/core/constants/validation-msg-constants";
import { getVegNonVegItemImg } from "src/app/shared/utils/menu-cart-item-functions";
import {
  FormControl,
  Validators,
  FormBuilder,
  FormGroup,
} from "@angular/forms";
import { CartCalService } from "../../cart/service/cart-cal.service";
import { MenuItemService } from "../../restaurant-details/service/menu-item.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { capitalizeFirstString } from "src/app/shared/utils/common-functions";
import { IonContent } from "@ionic/angular";

@Component({
  selector: "app-addon-variant",
  templateUrl: "./addon-variant.component.html",
  styleUrls: ["./addon-variant.component.scss"],
})
export class AddonVariantComponent implements OnInit, AfterViewInit {
  variantForm: FormGroup;
  addonList = [];
  variantList = [];
  selectedAddons = [];
  menuItemModel = new MenuItem();
  addonModel = new Addons();
  variantModel = new Variant();
  selectedVariant = {};
  menuItems: any;
  offerPrice = 0;
  totalCost = 0;
  totalVariantCost = 0;
  showQty = 1;
  selectedItems = 0;
  counter = 0;
  errorMessage = ''
  @ViewChild(IonContent, { static: false }) content: IonContent;

  @Input() public modalObj;
  constructor(
    private fb: FormBuilder,
    private renderer: Renderer2,
    private toasterService: ToastService,
    private activeModal: NgbActiveModal,
    public modalService: NgbModal,
    private menuItemService: MenuItemService,
    private cartCalService: CartCalService
  ) { }

  ngOnInit() {
    if (this.modalObj) {
      this.menuItems = this.modalObj.item;
      console.log(this.modalObj);
      console.log("cart", this.modalObj.cart);

      this.addonList = this.modalObj.addons.filter(
        (item) => item.isVariant === false
      );
      this.variantList = this.modalObj.addons.filter(
        (item) => item.isVariant === true
      );
      console.log("------->Variant List", this.variantList);
      console.log("------->Addons List", this.addonList);

      if (this.modalObj.cart) {
        this.menuItems = this.modalObj.item;
        this.selectedAddons = this.modalObj.item.addons;
        this.selectedVariant = this.modalObj.item.variant;
        this.getAddonsCost();
        this.showQty = this.modalObj.item.quantity;
        this.selectedAddons.forEach((ele) => {
          this.checkInputDisabled(ele, true);
        })
      }
      if(this.modalObj.item.config && this.modalObj.item.config.minQty && this.modalObj.item.config.minQty > 0){
        this.showQty = this.modalObj.item.config.minQty;
      }
    }
    this.initForm();
    if (this.variantList && this.variantList.length > 0) {
      this.getVariantCost();
    } else {
      this.totalVariantCost = this.menuItems.price;
    }
  }
  initForm() {
    let selectOption = "";
    const selectedVariant = this.modalObj.item.variant;
    console.log(selectedVariant);
    if (selectedVariant && selectedVariant.options) {
      selectOption = selectedVariant.options["optionName"];
    } else if (this.variantList.length > 0) {
      selectOption = this.variantList[0].options[0].optionName;
    }
    this.variantForm = this.fb.group({
      options: new FormControl(selectOption, [Validators.required]),
    });
    console.log(this.variantList);
  }

  getVegNonVegImg(isVeg, containsEgg) {
    return getVegNonVegItemImg(isVeg, containsEgg);
  }

  // checkbox options
  optionSet(option, addonId) {
    let select = false;
    const selectAddons = this.modalObj.item.addons;
    if (selectAddons.length > 0) {
      const findAddon = selectAddons.find((item) => item.addonId === addonId);
      if (findAddon) {
        const matchOption = findAddon.options.find(
          (op) => op.optionName === option.optionName
        );
        if (matchOption) {
          select = true;
        }
      }
    }
    return select;
  }
  generateAddonsString(minSelection, maxSelection) {
    let displayString = "";
    if (minSelection === 0) {
      switch (maxSelection) {
        case 1:
          displayString = "Select one add-on";
          break;
        default:
          displayString = `Select up to ${maxSelection} add-ons`;
      }
    } else if (minSelection === 1 && maxSelection === 1) {
      displayString = "Select any one option:";
    } else {
      displayString = `Select ${minSelection} to ${maxSelection} add-on(s)`;
    }
    return displayString;
  }

  // checkbox addons data
  async onAddonChange(event, option, addons) {
    await this.checkInputDisabled(addons, true);
    if (event.target.checked === true) {
      this.pushAddonObj(addons, option);
      if (this.selectedAddons.length > 0) {
        const addonsObj = this.selectedAddons.find(
          (item) => item.addonId === addons.addonId
        );
        if (addonsObj) {
          addonsObj.options.push(option);
        } else {
          this.selectedAddons.push(this.addonModel);
        }
      } else {
        this.selectedAddons.push(this.addonModel);
        this.checkInputDisabled(addons, true);
      }
      this.checkInputDisabled(addons, true);
    } else {
      this.checkInputDisabled(addons, false);
      this.selectedAddons.forEach((addon, index) => {
        if (addon.addonId === addons.addonId) {
          let ind = addon.options.findIndex(
            (ind) => ind.optionName === option.optionName
          );
          addon.options.splice(ind, 1);
          if (addon.options.length === 0) {
            this.selectedAddons.splice(index, 1);
          }
        }
      });
    }
    this.getAddonsCost();
  }

  async checkInputDisabled(addons, valid) {
    const inputRef = await document.getElementsByClassName(`${addons.addonId}`);

    if (valid) {
      const currentAddId = this.selectedAddons.find(
        (addId) => addId.addonId == addons.addonId
      );
      if (!currentAddId) {
        this.selectedItems = 0;
      } else {
        this.selectedItems = currentAddId.options.length;
      }
      if (this.selectedItems < addons.maxSelection) {
        this.selectedItems++;
      } else {
        for (let i = 0; i < inputRef.length; i++) {
          if (!(inputRef[i] as HTMLInputElement).checked) {
            (inputRef[i] as HTMLInputElement).disabled = true;
          } else {
            (inputRef[i] as HTMLInputElement).disabled = false;
          }
        }
      }
    } else {
      for (let i = 0; i < inputRef.length; i++) {
        (inputRef[i] as HTMLInputElement).disabled = false;
      }
    }
  }

  onChangeVariant(event) {
    this.getVariantCost();
  }
  getVariantCost() {
    const optionObj = this.variantList[0]["options"].find(
      (item) => item.optionName === this.variantForm.controls["options"].value
    );
    this.totalVariantCost = optionObj.cost;
  }
  getAddonsCost() {
    console.log("called");
    let addOnsCost = 0;
    this.selectedAddons.forEach((ele) => {
      console.log(ele);
      ele.options.map((a) => {
        console.log(a);
        return (addOnsCost += a.cost);
      });
    });
    this.totalCost = addOnsCost;
  }

  pushAddonObj(addon, option) {
    this.addonModel = new Addons();
    this.addonModel["addonId"] = addon.addonId;
    this.addonModel["addonName"] = addon.addonName;
    this.addonModel["isVariant"] = addon.isVariant;
    this.addonModel["maxSelection"] = addon.maxSelection;
    this.addonModel["minSelection"] = addon.minSelection;
    this.addonModel["options"].forEach((obj) => {
      obj["optionName"] = option.optionName;
      obj["isVeg"] = option.isVeg;
      obj["cost"] = option.cost;
      obj["offerPrice"] = option.offerPrice;
    });
  }

  pushVariantObj(variant, option) {
    this.variantModel["addonId"] = variant.addonId;
    this.variantModel["addonName"] = variant.addonName;
    this.variantModel["isVariant"] = variant.isVariant;
    this.variantModel["options"] = { ...option };
  }
  // for close model
  onCloseAddonModal() {
    this.activeModal.dismiss();
  }

  // for save data in cart
  onSaveAddon() {
    if (this.variantForm.controls["options"].value !== "") {
      const optionObj = this.variantList[0]["options"].find(
        (item) => item.optionName === this.variantForm.controls["options"].value
      );
      this.pushVariantObj(this.variantList[0], optionObj);
      if (optionObj) {
        this.selectedVariant = { ...this.variantModel };
      }
    }
    console.log(this.selectedVariant, this.selectedAddons, this.menuItems);
    this.validationAddonVariantList();
  }

  // validating the addons and variants and on that error msgs
  validationAddonVariantList() {
    if (this.selectedAddons.length > 0 || this.selectedVariant["isVariant"]) {
      if (this.variantList.length > 0) {
        if (this.selectedVariant["isVariant"]) {
          if (this.addonList.length > 0) {
            const addonsArrayList = JSON.parse(
              JSON.stringify(this.selectedAddons)
            );
            this.addonsValidation(addonsArrayList);
          } else {
            this.customMenuItemAdd();
          }
        } else if (this.variantList[0]["minSelection"] > 0) {
          const message = ErrorMessage.VARIANT_SELECTION_REQ_MEG;
          this.toasterService.presentToast(message, "", "error");
        }
      } else {
        if (this.addonList.length > 0) {
          const addonsArrayList = JSON.parse(
            JSON.stringify(this.selectedAddons)
          );
          if (this.selectedAddons.some((addon) => addon.isVariant === false)) {
            this.addonsValidation(addonsArrayList);
          }
        }
      }
    } else {
      if (this.variantList.length > 0) {
        if (this.variantList[0]["minSelection"] > 0) {
          const message = ErrorMessage.VARIANT_SELECTION_REQ_MEG;
          this.toasterService.presentToast(message, "", "error");
        }
      } else if (this.addonList.length > 0) {
        if (this.addonList.some((addon) => Number(addon.minSelection) >= 1)) {
          let message;
          if (this.addonList.length === 1) {
            message = ErrorMessage.ADDON_SELECTION_REQ_MEG;
          } else {
            message = ErrorMessage.ADDONS_SELECTION_REQ_MEG;
          }
          this.toasterService.presentToast(message, "", "error");
        } else {
          this.customMenuItemAdd();
        }
      } else {
        this.customMenuItemAdd();
      }
    }
  }

  // addons validation
  addonsValidation(addonsArrayList) {
    let validate = [];
    for (let i = 0; i < this.addonList.length; i++) {
      const addons = addonsArrayList.some(
        (item) => item.addonName === this.addonList[i].addonName
      );
      let tostKey;
      if (addons) {
        for (let j = 0; j < addonsArrayList.length; j++) {
          if (this.addonList[i].addonName === addonsArrayList[j].addonName) {
            if (
              addonsArrayList[j].minSelection <=
              addonsArrayList[j].options.length
            ) {
              validate.push(true);
            } else {
              validate.push(false);
              this.onScrollEachAddonOnError(this.addonList[i].addonId)
              console.log(this.addonList[i])

              this.errorMessage = (this.addonList[i].displayName || this.addonList[i].addonName) +
                " Minimum selection " +
                this.addonList[i].minSelection;
              this.onClick(null, 'min')
              tostKey = true;
            }
          }
        }
      } else {
        if (this.addonList[i].minSelection > 0) {
          validate.push(false);
          this.onScrollEachAddonOnError(this.addonList[i].addonId)
          console.log(this.addonList[i])
          this.errorMessage = (this.addonList[i].displayName || this.addonList[i].addonName) +
            " Minimum selection " +
            this.addonList[i].minSelection;
          this.onClick(null, 'min')
          tostKey = true;
        }
      }
      if (tostKey === true) break;
    }
    if (!validate.includes(false)) {
      console.log("check me");
      // customized menu item or outlet adding in order object
      this.customMenuItemAdd();
    }
  }
  onScrollEachAddonOnError(addonName) {
    const addonSec = document.getElementById(`${addonName}`);
    // const addonSectext = document.querySelector(".addonsListName");
    // const animationText = document.getElementById(`${addonName}anima`);
    const itemDesHeight = document.querySelector('.items-description-section').clientHeight
    const itemTitleHeight = document.querySelector('.item-title').clientHeight
    const totalHeight = itemDesHeight + itemTitleHeight + 20
    this.content.scrollToPoint(0, addonSec.offsetTop - totalHeight, 300);
    setTimeout(() => {
      this.renderer.addClass(addonSec, "custom-animation")
      // animationText.style.display = 'grid'
    }, 300);
    setTimeout(() => {
      this.renderer.removeClass(addonSec, "custom-animation")
    }, 800)
    // setTimeout(() => {
    //   animationText.style.display = 'none'
    // }, 1300)
  }

  pushMenuItem(menu, addons) {
    this.menuItemModel = new MenuItem();
    this.menuItemModel._outletId = menu.outletId;
    this.menuItemModel._itemId = menu.itemId;
    this.menuItemModel._name = menu.name;
    this.menuItemModel._quantity = menu.quantity;
    this.menuItemModel._isVeg = menu.isVeg;
    this.menuItemModel._gst = menu.gst;
    this.menuItemModel._price = menu.price;
    this.menuItemModel._offerPrice = menu.offerPrice;
    this.menuItemModel._containsEgg = menu.containsEgg;
    this.menuItemModel._totalAmount = 0; //
    this.menuItemModel._addons = addons;
    this.menuItemModel["variant"] = this.selectedVariant;
    this.menuItemModel["additionalCharges"] = menu["additionalCharges"];
    return this.menuItemModel;
  }

  customMenuItemAdd() {
    this.menuItemModel = this.pushMenuItem(this.menuItems, this.selectedAddons);
    const updateMenu = JSON.parse(JSON.stringify(this.menuItemModel));
    if (!this.modalObj.cart) {
      const customAddons = AppData.selectedAddonsList;
      if (customAddons.length > 0) {
        this.modalObj.addons.forEach((addon) => {
          const findAddon = customAddons.find(
            (itm) => itm.addonId === addon.addonId
          );
          if (!findAddon) {
            customAddons.push(addon);
          }
        });
      } else {
        customAddons.push(...this.modalObj.addons);
      }
      AppData.selectedAddonsListSub$.next(customAddons);
    }
    updateMenu["qnty"] = this.showQty;
    this.activeModal.close(JSON.parse(JSON.stringify(updateMenu)));
  }

  getOfferPrice(offerList, price) {
    if (offerList) {
      this.offerPrice = this.menuItemService.getOfferPrice(offerList, price);
    } else if (this.menuItems.offer) {
      this.offerPrice = this.cartCalService.calculateDiscount(
        this.menuItems.offer,
        price
      );
    }

    return this.offerPrice;
  }

  setDiscountVal(option) {
    if (option.cost && option.cost < option.originalCost) {
      return true;
    }
    return false;
  }

  setCost(option) {
    if (option.cost !== null) {
      return option.cost;
    } else {
      return option.originalCost;
    }
  }
  ngAfterViewInit() {
    const itemTitleSec = document.querySelector(".items-title-section");
    const itemQntySec = document.querySelector(".item-qty-section");
    this.renderer.setStyle(itemQntySec, "top", itemTitleSec.clientHeight + 20 + "px !important")

  }
  scrollEvent(event, isVirtualScroll?) {
    // console.log('called')
    const itemTitileSec = document.querySelector(".item-title");
    const itemsDescription = document.querySelector(".items-description");
    const stickydiv = document.querySelector(".item-qty-section");
    this.renderer.setStyle(stickydiv, "top", itemTitileSec.clientHeight - 3 + "px");
    const scrollPosition = event.detail.scrollTop;
    // this.renderer.setStyle(itemsDescription,"paddingLeft","40px")
    if (scrollPosition > 40) {
      // this.renderer.setStyle(itemsDescription, "opacity", "0");
    } else {
      // this.renderer.setStyle(itemsDescription, "opacity", "1");
    }
  }

  onItemDecrease() {
    if (this.showQty <= 1 || (this.modalObj.item.config && this.modalObj.item.config.minQty && this.showQty <= this.modalObj.item.config.minQty)) {
      this.modalService.dismissAll();
    } else {
      this.showQty -= 1;
    }
  }

  onItemIncrease() {
    if(!this.modalObj.item.config || !this.modalObj.item.config.maxQty || this.showQty < this.modalObj.item.config.maxQty){
      this.showQty += 1;
    } else {
      this.errorMessage = `Maximum quantity ${this.modalObj.item.config.maxQty} reached`
      this.errorPopups()
    }
  }
  onClick(inputEle, type) {
    if (inputEle && inputEle.disabled) {
      this.errorMessage = 'Maximum add-ons selected'
      this.errorPopups()
    }
    if (type === 'min') {
      this.errorPopups()
    }
  }
  errorPopups() {
    const errorPopups = document.getElementById("err-popups");
    if (errorPopups.offsetTop > 0) {
      this.renderer.addClass(errorPopups, "animate-add");
      this.renderer.removeClass(errorPopups, "animate-remove");

      setTimeout(() => {
        this.renderer.addClass(errorPopups, "animate-remove");
        this.renderer.removeClass(errorPopups, "animate-add");
      }, 2000);
    }
  }


  capitalizeFirstString(description) {
    return capitalizeFirstString(description);
  }
}
